"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  toolbar: {
    items: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'alignment', '|', 'indent', 'outdent', '|', 'fontFamily', 'fontColor', '|', 'blockQuote', 'horizontalLine', 'insertTable', 'mediaEmbed', 'ckfinder', '|', 'undo', 'redo', 'removeFormat']
  }
};
exports["default"] = _default;